import { UI, useDayPicker, RootProps } from 'react-day-picker';

const classes = {
  Wrapper: 'flex-1'
};

export const CalendarRoot = ({ children, ...props }: RootProps) => {
  const dayPicker = useDayPicker();
  const components = dayPicker.components;
  const classNames = dayPicker.classNames;

  return (
    <div {...props}>
      <div className={classes.Wrapper}>
        {children}
        <components.Footer className={classNames[UI.Footer]} />
      </div>
    </div>
  );
};
